// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2-HGk","footer":"ModalInfo_footer__LFdnY"};